import i18n from "i18next";
import detector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

const resources = {
  en: {
    translation: {
      imageUploader: {
        dimensions: "Recommended image format (1050px x 875px)",
      },
      sendVerificationEmail: "Send verification email",
      accountVerified: "Your confirmation was successful!",
      accountUnverified: "Please confirm your e-mail address!",
      setNewPassword: {
        header: "Set New Password",
      },
      thankyou: {
        title: "Hello, thank you for your application.",
        description:
          "You can easily change your own application by logging back in to the portal!",
        p1: "There will not be any further confirmation of your application, also not when you change your application.",
        p2: 'We will contact you later in the process, in the meantime please visit our website <linkTag href="https://www.colognepride.de" target="_blank">www.colognepride.de</linkTag> and follow us on Facebook for the latest news.',
        thankyou: "Thank you,",
        from: "Colognepride e.V.",
      },
      submissions: {
        filter: {
          label: "Filter",
          options: {
            deleted: "Deleted",
            completed: "Completed",
            incomplete: "Incomplete",
          },
        },
      },
      cards: {
        labels: {
          view: "View Form",
          submit: "Submit Form",
        },
      },
      labels: {
        export: "Export",
        delete: "Delete",
        cancel: "Cancel",
      },
      modals: {
        delete: {
          title: "Confirm Deletion",
          description: "Are you sure you want to delete this record?",
        },
      },
      forms: {
        volunteering: {
          description:
            "Binding registrations for events during the two-week ColognePride. These will appear online here and in our official program booklet!",
          ended:
            'The registration deadline has passed.<br /> Do you still want to take part? Then write to <linkTag href="mailto:demoengel@colognepride.de" target="_blank">demoengel@colognepride.de</linkTag> or <linkTag href="mailto:ehrenamt@colognepride.de" target="_blank">ehrenamt@colognepride.de</linkTag>',
        },
        demo: {
          description:
            "Registration for participants with vehicles and pedestrian groups from 10 persons.",
          ended:
            'The registration period has expired. If you want to register a group later, please write to <linkTag href="mailto:demo@colognepride.de" target="_blank">demo@colognepride.de</linkTag>',
          labels: {
            demoAngel: {
              description:
                "Training on Friday July 7, 2023 starting at 6 p.m. (approximately 2 hours). <br>Deployment time Sunday July 9 from 6:30 a.m. to approx. 6 p.m.",
            },
            registerVehicle: "Do you want to register a vehicle?",
            registerAnotherVehicle: "Do you want to register another vehicle?",
          },
        },
        event: {
          description:
            "Registration for ColognePride 2025 events for the event calendar online and the programme booklet.",
          ended:
            "Registrations for Cologne Pride 2025 events are unfortunately no longer possible.",
          inputs: {
            location: {
              label: "Event Location",
            },
            entrance: {
              label: "Event Entrance",
            },
            furtherInformation: {
              label: "Further Information (i.e. accessibility etc.)",
            },
          },
        },
        submissionConditions: {
          privacyPolicy:
            '<linkTag href="#" target="_blank">Privacy policy</linkTag> accepted',
        },
        footer: {
          submit: "Submit",
          update: "Save Changes",
        },
      },
      register: {
        description: {
          l1: "Don't have an account yet?",
          l2: "Here you can easily register.",
        },
        termsAndConditions:
          'I agree to the terms and conditions and <linkTag href="#" target="_blank">privacy policy</linkTag> of Cologne Pride.',
        toLogin: "Already have an account? Login.",
      },
      eventRegistration: {
        header: {
          heading: "Costs:",
          p1: "Non-commercial events (exhibitions, etc.) for which no admission fee is charged can become official cooperation partners of the “ColognePride Event” free of charge.",
          p2: {
            p: "Commercial events such as parties, concerts, and similar events (i.e., individual events with admission fees) pay the following fees based on the expected number of guests (please provide a self-assessment):",
            i1: {
              col1: "Small events organized by clubs with up to 30 expected guests",
              col2: "voluntary donation",
            },
            i2: {
              col1: "Events with up to 200 expected guests",
              col2: "€120",
            },
            i3: {
              col1: "Events with up to 500 expected guests",
              col2: "€200",
            },
            i4: {
              col1: "Events with up to 1,000 expected guests",
              col2: "€350",
            },
            i5: {
              col1: "Events with more than 1,000 expected guests",
              col2: "on request",
            },
            i6: { col1: "(based on self-assessment)" },
          },
          p3: {
            p: "After the <b>editorial deadline for the program booklet on May 5</b>, only online listings on our homepage will be possible. In this case, the fees will change as follows:",
            i1: {
              col1: "Small events organized by clubs with up to 30 expected guests",
              col2: "voluntary donation",
            },
            i2: {
              col1: "Events with up to 200 expected guests",
              col2: "€80",
            },
            i3: {
              col1: "Events with up to 500 expected guests",
              col2: "€150",
            },
            i4: {
              col1: "Events with up to 1,000 expected guests",
              col2: "€200",
            },
            i5: {
              col1: "Events with more than 1,000 expected guests",
              col2: "on request",
            },
            i6: { col1: "(based on self-assessment)" },
          },
          p4: "Events organized by trendy bars and clubs that have been specially designed for ColognePride cost €60 each (it is NOT possible to include regular happy hour offers or similar in the ColognePride program!).",
          p5: "<b>The prices quoted are exclusive of the statutory sales tax.</b>",
        },
        footer:
          "Note: We reserve the right to make editorial changes and shorten the description text as well as the use of submitted images at our own discretion.",
      },
    },
  },
  de: {
    translation: {
      "Approving...": "Wird geprüft...",
      "Not visible on colognepride?": "Auf colognepride nicht sichtbar?",
      "Try again": "Versuche es erneut",
      Approved: "Genehmigt",
      imageUploader: {
        dimensions: "Empfohlenes Bildformat (1050px x 875px)",
      },
      sendVerificationEmail: "Bestätigungsmail senden",
      accountVerified: "Bestätigung erfolgreich!",
      accountUnverified: "Bitte bestätige deine E-Mail Adresse!",
      setNewPassword: {
        header: "Passwort zurücksetzen",
      },
      thankyou: {
        title: "Hallo und Danke für Deine Anmeldung.",
        description:
          "Du kannst deine Daten jederzeit selbständig über dein LogIn ändern! Merke dir bitte unbedingt dein Passwort.",
        p1: "Eine weitere Bestätigung Deiner Anmeldung erfolgt nicht, auch nicht bei vorgenommen Änderungen oder Anmeldungen.",
        p2: 'Wir setzen uns zur gegeben Zeit wieder mit Dir in Verbindung, bis dahin beachte bitte unsere Webseite <linkTag href="https://www.colognepride.de" target="_blank">www.colognepride.de</linkTag> und folge uns gerne auf Instagram (cologneprideofficial) und Facebook.',
        thankyou: "Vielen Dank",
        from: "Colognepride e.V.",
      },
      submissions: {
        filter: {
          label: "Filter",
          options: {
            deleted: "Archivierte",
            completed: "Erledigt",
            incomplete: "Unvollständige",
          },
        },
      },
      cards: {
        labels: {
          view: "Formular ansehen",
          submit: "Jetzt anmelden",
        },
      },
      labels: {
        delete: "Löschen",
        cancel: "Abbrechen",
        export: "Exportieren",
      },
      modals: {
        delete: {
          title: "Bestätigen Sie die Löschung",
          description:
            "Sind Sie sicher, dass Sie diesen Datensatz löschen möchten?",
        },
      },
      forms: {
        volunteering: {
          description:
            "Verbindliche Anmeldungen von Veranstaltungen und Events während des zweiwöchigen ColognePride. Diese erscheinen online hier und in unserem offiziellen Programmheft!",
          ended:
            'Die Anmeldefrist ist abgelaufen.<br /> Willst Du trotzdem dabei sein? Dann schreibe an <linkTag href="mailto:demoengel@colognepride.de" target="_blank">demoengel@colognepride.de</linkTag> oder <linkTag href="mailto:ehrenamt@colognepride.de" target="_blank">ehrenamt@colognepride.de</linkTag>',
        },
        demo: {
          description:
            "Anmeldung für Teilnehmende mit Fahrzeugen und Fußgruppen ab 10 Personen.",
          ended:
            'Die Anmeldefrist ist abgelaufen. Wenn Du eine Gruppe nachmelden willst, dann schreibe an <linkTag href="mailto:demoengel@colognepride.de" target="_blank">demo@colognepride.de</linkTag>',
          labels: {
            demoAngel: {
              description:
                "Schulung am Freitag 7. Juli 2023 ab 18 Uhr (ca. 2 Stunden).“ und „<br>Einsatzzeit Sonntag 9. Juli ab 6:30 bis ca. 18 Uhr",
            },
            registerVehicle: "Möchtest Du ein Fahrzeug anmelden?",
            registerAnotherVehicle:
              "Möchten Sie ein anderes Fahrzeug zulassen?",
          },
        },
        event: {
          description:
            "Verbindliche Anmeldung für Veranstaltungen innerhalb des ColognePride für den Veranstaltungskalender online und das offizielle Programmheft.",
          ended:
            "Anmeldungen für Cologne Pride 2025 Veranstaltungen sind leider nicht mehr möglich.",
          inputs: {
            location: {
              label: "Veranstaltungsort",
            },
            entrance: {
              label: "Eintritt",
            },
            furtherInformation: {
              label: "Weitere Informationen (z. B. Zugänglichkeit usw.)",
            },
          },
        },
        submissionConditions: {
          privacyPolicy:
            '<linkTag href="#" target="_blank">Datenschutz</linkTag> akzeptiert',
        },
        footer: {
          submit: "Jetzt anmelden",
          update: "Änderungen speichern",
        },
      },
      register: {
        description: {
          l1: "Du hast noch kein Konto?",
          l2: "Hier kannst du dich ganz einfach registrieren.",
        },
        termsAndConditions:
          'Ich stimme den Nutzungsbedingungen und der <linkTag href="#" target="_blank">Datenschutzrichtlinie</linkTag> von Cologne Pride zu.',
        toLogin: "Du hast bereits ein Konto, dann logge dich hier ein",
      },
      eventRegistration: {
        header: {
          heading: "Kosten:",
          p1: "Nichtkommerzielle Veranstaltungen (Ausstellungen etc.), für die kein Eintrittsgeld erhoben wird, können kostenfrei offizieller Kooperationspartner „ColognePride Veranstaltung“ werden.",
          p2: {
            p: "Kommerzielle Veranstaltungen wie Partys, Konzerte und ähnliches (d.h. Einzelveranstaltungen mit Eintrittsgebühren) zahlen entsprechend der erwarteten Anzahl ihrer Gäste (bitte durch Angabe einer Selbsteinschätzung) folgende Gebühren:",
            i1: {
              col1: "Kleine Veranstaltungen von Vereinen bis 30 erwartete Gäste",
              col2: "gegen freiwillige Spende",
            },
            i2: {
              col1: "Veranstaltungen bis 200 erwartete Gäste",
              col2: "120,- €",
            },
            i3: {
              col1: "Veranstaltungen bis 500 erwartete Gäste",
              col2: "200,- €",
            },
            i4: {
              col1: "Veranstaltungen bis 1.000 erwartete Gäste",
              col2: "350,- €",
            },
            i5: {
              col1: "Veranstaltungen ab 1.000 erwartete Gäste",
              col2: "auf Anfrage",
            },
            i6: { col1: "(nach Selbsteinschätzung)" },
          },
          p3: {
            p: "Nach <b>Redaktionsschluss des Programmheftes am 05. Mai</b> kann nur eine online-Listung auf unserer Homepage erfolgen. Hier ändern sich die Gebühren wie folgt:",
            i1: {
              col1: "Kleine Veranstaltungen von Vereinen bis 30 erwartete Gäste",
              col2: "gegen freiwillige Spende",
            },
            i2: {
              col1: "Veranstaltungen bis 200 erwartete Gäste",
              col2: "80,- €",
            },
            i3: {
              col1: "Veranstaltungen bis 500 erwartete Gäste",
              col2: "150,- €",
            },
            i4: {
              col1: "Veranstaltungen bis 1.000 erwartete Gäste",
              col2: "200,- €",
            },
            i5: {
              col1: "Veranstaltungen ab 1.000 erwartete Gäste",
              col2: "auf Anfrage",
            },
            i6: { col1: "(nach Selbsteinschätzung)" },
          },
          p4: "Veranstaltungen von Szenekneipen und Szeneclubs, die speziell für den ColognePride konzipiert wurden, zahlen jeweils 60,- EUR (eine Einbindung von regulären Happy-Hour-Angeboten o.ä. in das ColognePride- Programm ist NICHT möglich!).",
          p5: "<b>Die genannten Preise verstehen sich zzgl. der gesetzlich vorgeschriebenen Umsatzsteuer</b>",
        },
        footer:
          "Hinweis: Wir behalten uns redaktionelle Änderungen und Kürzungen des Beschreibungstexts sowie die Verwendung von eingeschickten Bildern nach eigenem Ermessen vor.",
      },
      Yes: "ja",
      or: "oder",
      No: "nein",
      "Passenger car": "PKW",
      City: "Stadt",
      Back: "Zurück",
      View: "Ansehen",
      Save: "Sichern",
      Group: "Gruppe",
      Email: "E-Mail",
      "Postal code / ZIP code": "PLZ",
      Country: "Land",
      Portal: "Portal",
      Search: "Suchen",
      Company: "Firma",
      Account: "Profil",
      Form: "Anmeldung",
      Users: "Benutzer",
      Saving: "Sichern",
      Delete: "Löschen",
      Forms: "Formulare",
      Saved: "Gesichert",
      Address: "Adresse",
      Continue: "Weiter",
      Login: "Anmeldung",
      Submit: "Absenden",
      Admin: "Verwaltung",
      Cancel: "Abbrechen",
      Logout: "Ausloggen",
      Vehicle: "Fahrzeug",
      Actions: "Aktionen",
      Password: "Passwort",
      Salutation: "Anrede",
      People: "Personen an",
      Event: "Veranstaltung",
      "Last Name": "Nachname",
      "Demo Team": "Demoteam",
      "First Name": "Vorname",
      Volunteering: "Ehrenamt",
      Register: "Registrieren",
      "Demo Angel": "Demoengel",
      Settings: "Einstellungen",
      Completed: "Abgeschlossen",
      Individual: "Person",
      "Registree / Submitter": "Anmeldende",
      "Phone Number": "Rufnummer",
      Organization: "Organisation",
      "Vehicle type": "Fahrzeugtyp",
      "Submit Form": "Jetzt anmelden",
      "Please wait": "Warten Sie mal",
      "Date of Birth": "Geburtsdatum",
      "New Password": "Neues Passwort",
      "Primary Vehicle Representative": "Wagenleiter:in",
      "Secondary Vehicle Representative": "Wagenleiter:in Vertreter:in",
      "Upload Image": "Bild hochladen",
      "Email Address": "E-Mail-Adresse",
      "Contact Person": "Kontaktperson",
      "Truck upto 7.5t": "LKW bis 7,5t",
      Submissions: "Eingereichte Anträge",
      "Drag image here or click to select file.":
        "Ziehen Sie das Bild hierher oder klicken Sie, um die Datei auszuwählen.",
      "Photo Credit Information": "Angabe zum Fotocredit",
      "Truck over 7.5t": "LKW über 7,5t",
      "Admin Permissions": "Admin-Rechte",
      "Demonstration Registration": "Demoanmeldung",
      "Save Password": "Passwort speichern",
      "Back to portal": "Zurück zum Portal",
      "License plate number": "Kennzeichen",
      "Save Changes": "Änderungen speichern",
      "Billing Address": "Rechnungsanschrift",
      "Event Date": "Datum der Veranstaltung",
      "Event Title": "Titel der Veranstaltung",
      "Current Password": "Aktuelles Passwort",
      "Discard Changes": "Änderungen verwerfen",
      "Other comments": "Sonstige",
      "Event End Time": "Ende der Veranstaltung",
      "Information on accessibility": "Angaben zur Barrierefreiheit",
      "People with physical disabilities":
        "Menschen mit körperlicher Behinderung",
      "People with hearing disabilities": "Menschen mit Hörbehinderung",
      "People with visual disabilities": "Menschen mit Sehbehinderung",
      "Photos only, no advertisements, logos, posters or flyers!":
        "Nur Fotos, keine Werbeanzeigen, Logos,  Plakate oder Flyer!",
      "Event description (max. 800 characters incl. spaces)":
        "Veranstaltungbeschreibung (höchstens 800 Zeichen inkl. Leerzeichen)",
      "Event Start Time": "Beginn der Veranstaltung",
      "Reset Password": "Passwort zurücksetzen",
      "Construction helper:": "Aufbauhelfer:in",
      "Forgot password?": "Passwort vergessen?",
      "Backstage helper:": "Backstagehelfer:in",
      "Request Changes": "Änderungen beantragen",
      "View Submission": "Eingereichtes Formular",
      "Trailer Plate Number": "Kennzeichen Anhänger",
      "Total weight (in kg)": "Gesamtgewicht (in kg)",
      "Event Registration": "Veranstaltungsanmeldung",
      "Confirm Password": "Neues Passwort wiederholen",
      "Meeting point helper:": "Meetingpointhelfer:in",
      "General Information": "Allgemeine Informationen",
      "Don't have an account?": "Sie haben kein Konto?",
      "Event Description": "Verantstaltungsbeschreibung",
      "Street and House Number": "Straße und Hausnummer",
      "Semi-truck": "Zugmaschine mit Auflieger",
      "Total height (in metres)": "Gesamthöhe (in meter)",
      "Total length (in metres)": "Gesamtlänge (in meter)",
      "Total width (in metres)": "Gesamtbreite (in meter)",
      "Check your inbox!": "Prüfe deinen E-Mail Postfach!",
      "Group name at the demonstration": "Gruppenname bei der Demo",
      "Group category {{number}}": "Gruppenkategorie {{number}}",
      "Already have an account?": "Sie haben bereits ein Konto?",
      "Pride bracelet distributor:": "Pridebändchen-Verteiler:in",
      "Request for change {{form}}": "Antrag auf Änderung {{form}}",
      "Possibly addition to the invoice": "Ggf. Zusatz auf Rechnung",
      "License plate number of tractor is identical.":
        "Kennzeichen Anhänger identisch",
      "Terms and conditions accepted": "Teilnahmebedingungen akzeptiert",
      "Confirm Changes": "Änderungen bestätigen",
      'Please review the changes before submitting. If you are satisfied with the changes, click on "Save" to submit. If not, click on "Discard" to discard the changes and return to the previous state.':
        'Bitte überprüfen Sie die Änderungen vor dem Übermitteln. Wenn Sie mit den Änderungen zufrieden sind, klicken Sie auf "Sichern", um zu übermitteln. Wenn nicht, klicken Sie auf "Verwerfen", um die Änderungen zu verwerfen und zum vorherigen Zustand zurückzukehren.',
      Discard: "Verwerfen",
      "Sign in to access your account.":
        "Melde dich an, um auf dein Konto zuzugreifen",
      "Training on {{when}} (2 hours)":
        "Schulung am {{when}} gegen 20 Uhr (2 Stunden)",
      "Here you can reset your password.":
        "Hier kannst du dein Passwort zurücksetzen.",
      "Resend Email": "E-Mail erneut senden",
      "Here you can update your profile.":
        "Hier kannst du dein Profil aktualisieren.",
      "Step {{currentStep}} of {{totalSteps}}":
        "Schritt {{currentStep}} von {{totalSteps}}",
      "Passenger transport on the loading area":
        "Personenbeförderung auf der Ladefläche",
      "If necessary, contact person on invoice":
        "Ggf. Kontaktperson auf Rechnung",
      "We may store your data for future events":
        "Wir dürfen deine Daten für weitere Veranstaltungen speichern",
      "Create your account and be part of the celebration!":
        "Erstelle dein Konto und sei Teil der Feierlichkeiten!",
      "The time will be coordinated individually.":
        "Zeit wird individuell abgestimmt",
      "Hours of operation {{when}} {{from}} - {{to}}":
        "Einsatzzeit {{when}} {{from}} - {{to}}",
      "Would you like to register for another event?":
        "Möchtest Du eine weitere Veranstaltung anmelden",
      "Presentation of your group and interpretation of the motto":
        "Vorstellung Deiner Gruppe und Umsetzung des Mottos",
      "Please enter your current password to <br />change your password.":
        "Bitte gebe dein aktuelles Passwort ein, um dein<br />Passwort zu ändern.",
      "The billing address is identical with the registered {{selected}} address.":
        "die Rechnungsanschrift ist identisch der Anmelden Person/Organisation/Gruppe",
      "We register a vehicle in accordance with the terms and conditions of participation as follows:":
        "Wir melden gemäß den Teilnahmebedingungen ein Fahrzeug wie folgt an",
      "I am interested in supporting the demo team in advance of the demo with a higher investment of time. I will be contacted by the demo manager about this":
        "Ich habe Interesse das Demoteam schon im Vorfeld der Demo mit einem höheren Zeitaufwand zu unterstützen. Hierzu werde ich durch den Demoleiter kontaktiert",
    },
  },
};

i18n
  .use(detector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    keySeparator: ".",
    nsSeparator: ">>",

    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    react: {
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ["br", "strong", "b", "i", "a"],
    },
  });

export default i18n;
